import * as Yup from "yup";

export const ValidationSchema = Yup.object().shape({
  ds_estado_civil: Yup.string()
    .trim()
    .required("O campo descrição é obrigatório."),
});
